import { useTranslation } from '@web_opxp/features';
import React, { useEffect, useMemo, useState } from 'react';
import { AssetsBaseUrl } from '../../assets';
import { getRandomMargin } from './utils';

export interface IQuestionProps {
  questionId: number;
  onAnswer: (answer: number) => void;
}

const AnswerLocas = ['Never', 'VeryRarely', 'Occasionally', 'QuiteOften', 'VeryOften'];

export default function Question({ questionId, onAnswer }: Readonly<IQuestionProps>) {
  const { t } = useTranslation();
  const questionLoca = `CFQ.Question.${questionId}`;
  const questionImgSrc = `${AssetsBaseUrl}/feature/cfq/questions/${questionId}.svg`;
  const [loading, setLoading] = useState(false);
  const loadingClass = loading ? ' loading' : '';
  const buttonStyles = useMemo(() => {
    return [0, 1, 2, 3, 4].map((index) => {
      const marginTop = index > 0 ? getRandomMargin() : 0;
      const marginRight = index < 4 ? getRandomMargin() : 0;
      const marginBottom = index < 4 ? getRandomMargin() : 0;
      const marginLeft = index > 0 ? getRandomMargin() : 0;
      const styles = {
        '--question-id': questionId,
        '--bubble-size': `${index}`,
        '--margin-top': `${marginTop}px`,
        '--margin-right': `${marginRight}px`,
        '--margin-bottom': `${marginBottom}px`,
        '--margin-left': `${marginLeft}px`,
      };
      return styles;
    });
  }, [questionId]);
  useEffect(() => {
    if (questionId > 0) {
      // set loading back to false when questionId changes
      setLoading(false);
    }
  }, [questionId]);
  const answers = [0, 1, 2, 3, 4].map((index) => {
    const answerLocaSuffix = AnswerLocas[index];
    const answerLoca = `CFQ.Questionnaire.Answers.${answerLocaSuffix}`;
    const answerCallback = () => {
      setLoading(true);
      onAnswer(index);
    };
    const answerClassname = `answer${loadingClass}`;
    return (
      <button
        key={`${questionId}.${index}`}
        disabled={loading}
        className={answerClassname}
        style={buttonStyles[index] as React.CSSProperties}
        onClick={answerCallback}>
        {t(answerLoca)}
      </button>
    );
  });

  return (
    <div className={`question${loadingClass}`}>
      <p>{t(questionLoca)}</p>
      <div className="columns">
        <div className="illustration">
          <img src={questionImgSrc} alt={t(questionLoca)} />
        </div>
        <div className="answers">{answers}</div>
      </div>
    </div>
  );
}
